import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/chain/eth_24.svg.ts
import { svg } from "lit";
var eth24Svg = ({ width, height }) => svg`
<svg width="${width ?? 24}" height="${height ?? 24}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_6718_21374)">
    <circle cx="12" cy="12" r="12" fill="#627EEA"/>
    <g clip-path="url(#clip1_6718_21374)">
      <path d="M11.9984 4.5L11.896 4.84186V14.7611L11.9984 14.8615L16.6848 12.1399L11.9984 4.5Z" fill="#C0CBF6"/>
      <path d="M11.999 4.5L7.3125 12.1399L11.999 14.8615V10.047V4.5Z" fill="white"/>
      <path d="M11.9982 15.732L11.9404 15.8011V19.3345L11.9982 19.5001L16.6874 13.0117L11.9982 15.732Z" fill="#C0CBF6"/>
      <path d="M11.999 19.5001V15.732L7.3125 13.0117L11.999 19.5001Z" fill="white"/>
      <path d="M11.998 14.8668L16.6844 12.1451L11.998 10.0522V14.8668Z" fill="#8197EE"/>
      <path d="M7.3125 12.1451L11.999 14.8668V10.0522L7.3125 12.1451Z" fill="#C0CBF6"/>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_6718_21374">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
    <clipPath id="clip1_6718_21374">
      <rect width="15" height="15" fill="white" transform="translate(4.5 4.5)"/>
    </clipPath>
  </defs>
</svg>
`;
export {
  eth24Svg
};
//# sourceMappingURL=eth_24.svg-QSL6GA7V.js.map
